// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"1601d9fa","598":"597767de"}[chunkId] + ".chunk.css";
};